module.exports = __webpack_public_path__ + "static/tv+net-f1c0ed82d314175354ccadc904c7b521.svg";